import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaChalkboardTeacher,
  FaBook,
  FaStar,
  FaUser,
  FaWallet,
  FaHome,
  FaEdit,
  FaBars,
  FaTimes,
  FaSignOutAlt,
  FaUserFriends, // ✅ NEW: Referral Icon
} from "react-icons/fa";

export default function TeacherSidebar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <>
      {/* Toggle Button */}
      <div className="md:hidden p-4 flex justify-between items-center bg-white shadow fixed top-0 left-0 right-0 z-50">
        <h1 className="text-xl font-semibold text-indigo-600">Teacher Panel</h1>
        <button onClick={toggleSidebar} className="text-2xl text-indigo-600">
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Sidebar */}
      <aside
        className={`fixed z-50 top-0 left-0 h-screen bg-white shadow-lg p-4 md:p-6 transform transition-transform duration-300 ease-in-out md:relative md:translate-x-0 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } w-64 md:w-64 flex flex-col overflow-y-auto`}
      >
        {/* Hide toggle button inside sidebar on large screens */}
        <div className="md:hidden flex justify-end">
          <button
            onClick={toggleSidebar}
            className="text-xl mb-4 text-indigo-600"
            aria-label="Close sidebar"
          >
            <FaTimes />
          </button>
        </div>

        <div className="text-center mb-8">
          <FaUser className="text-4xl mx-auto text-indigo-600" />
          <h2 className="text-lg font-semibold mt-2">John Doe</h2>
          <p className="text-sm text-gray-600">Math Teacher</p>
          <Link to="/teacher/edit-profile">
            <button className="mt-2 text-sm text-indigo-500 hover:underline flex items-center justify-center mx-auto">
              <FaEdit className="mr-1" /> Edit Profile
            </button>
          </Link>
        </div>

        <nav className="space-y-4">
          <Link
            to="/teacher/dashboard"
            className="flex items-center text-gray-700 hover:text-indigo-600"
            onClick={() => setIsOpen(false)}
          >
            <FaHome className="mr-2" /> Home
          </Link>
          <Link
            to="/teacher/wallet"
            className="flex items-center text-gray-700 hover:text-indigo-600"
            onClick={() => setIsOpen(false)}
          >
            <FaWallet className="mr-2" /> Wallet
          </Link>
          <Link
            to="/teacher/create-class"
            className="flex items-center text-gray-700 hover:text-indigo-600"
            onClick={() => setIsOpen(false)}
          >
            <FaChalkboardTeacher className="mr-2" /> Live Sessions
          </Link>
          <Link
            to="/teacher/post-material"
            className="flex items-center text-gray-700 hover:text-indigo-600"
            onClick={() => setIsOpen(false)}
          >
            <FaBook className="mr-2" /> Materials
          </Link>
          <Link
            to="/teacher/ratings"
            className="flex items-center text-gray-700 hover:text-indigo-600"
            onClick={() => setIsOpen(false)}
          >
            <FaStar className="mr-2" /> Ratings
          </Link>
          <Link
            to="/teacher/referral" // ✅ New Referral Link
            className="flex items-center text-gray-700 hover:text-indigo-600"
            onClick={() => setIsOpen(false)}
          >
            <FaUserFriends className="mr-2" /> Referral
          </Link>
          <button
            onClick={handleLogout}
            className="flex items-center text-red-600 hover:text-red-800 focus:outline-none"
          >
            <FaSignOutAlt className="mr-2" /> Logout
          </button>
        </nav>
      </aside>

      {/* Backdrop for mobile when sidebar is open */}
      {isOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black opacity-40 md:hidden z-40"
        ></div>
      )}
    </>
  );
}
